<template>
  <div class="rating-container">
    <content-loader height="80">
      <circle cx="20" cy="30" r="20"/>
      <rect x="45" y="15" rx="4" ry= "4" width="40%" height="10"/>
      <rect x="45" y="30" rx="4" ry= "4" width="75" height="12"/>
      <rect x="45" y="50" rx="4" ry= "4" width="80%" height="10"/>
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader} from "vue-content-loader";

export default {
  name: "SolutionRatingLoadingIndicator",
  components: { ContentLoader },
  props: {height: {type: Number, default: 600}},
}
</script>

<style scoped>

</style>